
  
const initState = {
    subscriber: [],
    page: 1,
    limit: 10,
    count: 0
  };
  
  const SubscriberReducer = (state = initState, action) => {
    switch (action.type) {
      case 'SET_SUBSCRIBER':
        return {
          ...state,
          subscriber: action.payload.data,
          page: action.payload.page,
          limit: action.payload.limit,
          count: action.payload.count
        };
      case 'RESET_STATE_SUBSCRIBER':
        return {
          ...state,
          ...initState
        };
      default:
        return { ...state };
    }
  };
  
  export default SubscriberReducer;
  